import {
    DefaultPlanLimits,
    PriceCalculationRequest,
    PricingPeriod,
    ProductPlan,
    SpecialPlanNames
} from "@/components/wpl/pricing/src/price-finder/constants.tsx";

export type ProductCalculationInputs = PriceCalculationRequest[];

export const getProductCalculationInputs = (
    productPlans: ProductPlan[],
    unitMinEnterprise: number,
    unitCount: number,
    billingCycle: PricingPeriod
): ProductCalculationInputs => {
    const getNumUnits = (planName: string, signupUnitLimit: number) => {
        let adjNumUnits = 0;

        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses

        // Free plan has no pricing
        const isFree = planName === SpecialPlanNames.FREE;

        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise =
            planName === SpecialPlanNames.ENTERPRISE &&
            billingCycle === "MONTHLY";

        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise =
            planName === SpecialPlanNames.ENTERPRISE &&
            unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;

        if (
            ![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)
        ) {
            adjNumUnits = unitCount;
        }

        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };

    const planPriceReqs: PriceCalculationRequest[] = productPlans.map(
        ({ offeringSku, planName, signupLimit }) => ({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(
                planName,
                signupLimit || DefaultPlanLimits.UNIT_LIMIT
            ),
            period: billingCycle
        })
    );

    return planPriceReqs;
};
